"use client";

import Button from "@marginly/ui/components/button";
import { cssVar } from "@marginly/ui/util/style";
import styled from "styled-components";

import { Navigation } from "./navigation";

export const BrandButton = styled(Button)`
  && {
    background: var(--fill-accent-primary, #9fe);
    color: var(--text-primary-on-brand, #000);
    &:hover {
      background: var(--fill-accent-primary-hover, #5cdfd4);
    }
  }
`;

export const LoginSectionDesktop = styled.div`
  display: none;
  @media (min-width: 1024px) {
    display: flex;
    gap: 8px;
  }
`;

export const LoginSectionMobile = styled.div`
  display: flex;
  gap: 4px;
  @media (min-width: 1024px) {
    display: none;
  }
`;

export const Logo = styled.div`
  width: 127px;
  height: 24px;

  background-image: var(--logo);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;

export const SelectedNetworkLogo = styled.div`
  display: flex;
  justify-content: center;
  padding: 12px;
  gap: 8px;
  align-items: center;
  background-color: var(--fill-accent-primary);
  margin-left: auto;
  border-radius: 8px;
  cursor: pointer;
  img {
    width: 24px;
    height: 24px;
  }
`;

export const SignInButton = styled.button`
  border-radius: 16px;
  background: #f7f3f2;
  padding: 5px 12px 7px;
  letter-spacing: 0.03em;
  color: #000000;
  font-family: "PlusJakartaSans";
  font-variation-settings: "wght" 700;
  font-size: 16px;
  line-height: 20px;
  border: 0;
  outline: 0;
`;

export const WalletRow = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  color: #72706e;
  letter-spacing: 0.5px;
  font-size: 12px;
  line-height: 16px;
`;

export const Nav = styled(Navigation)`
  z-index: 1500;
  border-radius: 0;
  padding: 0;
  transition: 300ms ease-out;
  // background: var(--background-accent-secondary, #defef9);
  &.warn {
    background: var(--background-negative);
    ${SignInButton} {
      background: #f5e5ea;
    }
  }
  &.good {
    background: var(--background-positive);
    ${SignInButton} {
      background: #f0faeb;
    }
  }
  &.home {
    background: var(--background-primary);
  }

  .ui-navigation__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin: 0 auto;
    padding: 0 22px;
    max-width: none;
    min-height: 96px;
  }

  &.scrolled {
    background: ${cssVar("--background-secondary")};
  }
`;
